<template>
    <div v-if="siteMenu" id="sidebar" class="sticky-top">

        <form @submit.prevent="search()">
            <div class="search-lesson-wrap">
                <label for="search-lesson" class="form-label sr-only">Search for a lesson</label>
                <input 
                    type="text" 
                    class="form-control" 
                    id="search-lesson" 
                    placeholder="Search for a lesson..."
                    @keyup="search()" 
                    v-model="searchValue"
                >
            </div>
            <ul class="search-lesson-filters">
                <li class="form-check" v-for="(menuItem, index) in siteMenu" :key="index">
                    <label class="form-check-label checkbox-container">
                        <input 
                            type="checkbox" 
                            class="form-check-input" 
                            :value="menuItem.slug"
                            @change="check($event)"
                        >
                        <span class="checkbox-button"></span>
                        <span class="checkbox-text">{{ menuItem.title }}</span>
                    </label>
                </li>
            </ul>
        </form>

    </div>
</template>

<script>
export default {
    name: "Sidebar",
    props: ["siteMenu"],
    data() {
        return {
            checkedFilters: [],
            searchValue: '',
            timeout: null
        }
    },
    methods: {
        check: function(e){
            if (e.target.checked){
                this.checkedFilters.push(e.target.value);
            } else {
                const index = this.checkedFilters.indexOf(e.target.value);
                if (index > -1) {
                    this.checkedFilters.splice(index, 1);
                }
            }
            this.$emit("checkedFilters", this.checkedFilters);
        },
        search: function(){

            // Clear timeout variable
            clearTimeout(this.timeout);

            var self = this;
            var text = self.searchValue;

            this.timeout = setTimeout(function(){

                self.$emit("searchText", text.trim());

            }, 400);
            
        }
    }
}
</script>

<style lang="scss" scoped>
    .search-lesson-wrap {

        margin-bottom: 1.5rem;

        #search-lesson {
            border: none;
            border-radius: 0;
            border-bottom: 1px solid #000000;
            padding: 0.375rem 0.5rem;

            &:focus {
                box-shadow: none;
            }

        }

    }

    .search-lesson-filters {

        padding-left: 0;
        list-style-type: none;

        .form-check {

            margin-bottom: 1rem;
            position: relative;
            font-size: 16px;

            span:hover {
                cursor: pointer;
            }

            input {
                position: absolute;
                opacity: 0;
                height: 0;
                width: 0;

                &:checked ~ .checkbox-button::after {
                    display: block;
                    background-color: var(--color-crimson);
                }

            }

            .checkbox-button {
                display: block;
                position: absolute;
                top: 6px;
                left: 0;
                height: 12px;
                width: 12px;
                border-radius: 2px;
                border: 1px solid #000000;

                &::after {
                    content: '';
                    width: 100%;
                    height: 100%;
                    border: 1px solid var(--color-white);
                    background-color: var(--color-white);
                    display: none;
                    transition: all 0.3s ease-in-out;
                }

            }

        }
        
    }
</style>